import { gql } from "@apollo/client";

const LINE_RETURN = gql`
  mutation lineReturn($input: LineReturn!) {
    lineReturn(input: $input) {
      status
      error
      data
    }
  }
`;

export default LINE_RETURN;
